import { render, staticRenderFns } from "./automations-node.vue?vue&type=template&id=48f29adc&scoped=true"
import script from "./automations-node.vue?vue&type=script&lang=js"
export * from "./automations-node.vue?vue&type=script&lang=js"
import style0 from "./automations-node.vue?vue&type=style&index=0&id=48f29adc&prod&lang=scss"
import style1 from "./automations-node.vue?vue&type=style&index=1&id=48f29adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f29adc",
  null
  
)

export default component.exports